/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { DialogService, DIALOG_CONFIG } from '@ngneat/dialog';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select, Store } from '@ngxs/store';
import { SocialAuthService, SocialUser } from 'angularx-social-login';
import {
  AgenciesApiService,
  Agency,
  AuthenticationService,
  CompaniesApiService,
  Profile,
  Reservation,
  User,
  UsersApiService,
} from 'rest-client';
import { from, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

import { ReservationService } from '@app/modules/core/services/reservation/reservation.service';
import {
  RemoveAuthAction,
  RemoveUserMessageAction,
  SetAgencyAction,
  SetUserAction,
  SetUserMessageAction,
} from '@app/modules/core/states/auth-state/auth.actions';
import {
  AuthStateModel,
  BookingMessage,
  CompanyStateModel,
} from '@app/modules/core/states/auth-state/auth.model';
import { AuthState } from '@app/modules/core/states/auth-state/auth.state';
import { SourceAndQueryParams } from '@app/modules/core/states/trip-state/trip.model';
import { TripState } from '@app/modules/core/states/trip-state/trip.state';
import { GoogleTagManagerService } from '@core/services/analytics/google-tag-manager.service';
import { environment } from '@env/environment';

import { ChangeUserModeDialogComponent } from '../change-user-mode-dialog/change-user-mode-dialog.component';
import { LoginDialogComponent } from '../login-dialog/login-dialog.component';
import { SignUpDialogComponent } from '../sign-up-dialog/sign-up-dialog.component';
const STATE_SNAPSHOT = 'state_snapshot';
const STATE_TIMESTAMP = 'state_timestamp';

@UntilDestroy()
@Component({
  selector: 'bkg-header',
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {
  @Select(AuthState.authData) authData$: Observable<AuthStateModel>;
  @Select(AuthState.userMessage) userMessages$: Observable<BookingMessage>;
  @Select(TripState.sourceAndQueryParams)
  sourceMode$: Observable<SourceAndQueryParams>;
  userData: User;
  agencyData: Agency;
  socialLoggedIn: boolean;
  accountLink: string;
  reservationsLink: string;
  goToErpReservation: string;
  userMessage: BookingMessage;
  isBusinessMode = false;
  companyData: CompanyStateModel;
  companyName: string = null;
  erp_mode = false;
  app_mode = false;
  client_app_mode = false;

  constructor(
    private authService: AuthenticationService,
    private socialAuthService: SocialAuthService,
    private dialog: DialogService,
    private store: Store,
    private usersApiService: UsersApiService,
    private agenciesApiService: AgenciesApiService,
    private router: Router,
    private googleTagManagerService: GoogleTagManagerService,
    private companiesApiService: CompaniesApiService,
    private reservationService: ReservationService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.checkLoggedUser();
    this.subscribeToUserData();
    this.subscribeToUserMessages();
    this.subscribeToSocialAuthState();
    this.subscribeToSourceData();
    //this.setWelcomeMessage();
  }

  onClickLogout(): void {
    from(this.authService.logout())
      .pipe(untilDestroyed(this))
      .subscribe(
        () => this.onSuccessLogout(),
        (err: HttpErrorResponse) => this.onErrorLogout(err)
      );
  }

  get goToPublic(): string {
    return environment.PUBLIC_URL;
  }

  get hasAuthData(): boolean {
    return !!this.userData?.id || !!this.agencyData?.id;
  }

  get isProd(): boolean {
    return environment.production;
  }

  private setWelcomeMessage(): void {
    const message: BookingMessage = {
      message: '¡Date prisa! Hay alta demanda para las fechas que buscas',
    };
    this.store.dispatch(new SetUserMessageAction(message));
  }

  private subscribeToSourceData(): void {
    this.sourceMode$
      .pipe(untilDestroyed(this))
      .subscribe((sourceAndUp: SourceAndQueryParams) => {
        // console.log(sourceAndUp);
        if (sourceAndUp.is_agent_token) {
          this.erp_mode = true;
          const reservationToken = this.route.snapshot.queryParamMap.get(
            'agent_res_token'
          );
          this.getReservationFromToken(reservationToken);
        }
        if (sourceAndUp.app_mode || sourceAndUp.client_app_mode) {
          this.app_mode = sourceAndUp.app_mode ?? false;
          this.client_app_mode = sourceAndUp.client_app_mode ?? false;
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          const userToken = JSON.parse(localStorage.getItem('auth_token'))
            ?.access_token;
          if (userToken) {
            this.authService
              .tokenParamLogin(userToken)
              // eslint-disable-next-line @typescript-eslint/no-unused-vars
              .then((result: any) => console.log());
          }
        }
      });
  }

  private subscribeToUserData(): void {
    this.authData$
      .pipe(untilDestroyed(this))
      .subscribe((authData: AuthStateModel) => {
        this.userData = authData.user;
        this.agencyData = authData.agency;
        this.isBusinessMode = !!authData.company;
        this.companyData = authData.company;
        this.companyName = this.companyData?.companyName;
        if (this.userData?.id) {
          this.reservationsLink = environment.PUBLIC_URL + '/c/reservations';
          this.accountLink = environment.PUBLIC_URL + '/c';
        } else {
          this.reservationsLink =
            environment.PUBLIC_URL + '/user/agencias/reservas';
          this.accountLink = environment.PUBLIC_URL + '/user/agencias/datos';
        }
      });
  }

  private getReservationFromToken(token: string): void {
    this.reservationService
      .getReservationByHash(token)
      .pipe(untilDestroyed(this))
      .subscribe((reservation: Reservation) => {
        this.goToErpReservation =
          environment.PUBLIC_URL + `/erp/reservation/view/${reservation.id}`;
      });
  }

  private subscribeToUserMessages(): void {
    this.userMessages$
      .pipe(untilDestroyed(this))
      .subscribe((userMessage: BookingMessage) => {
        this.userMessage = userMessage;
      });
  }

  private onSuccessLogout(): void {
    if (this.socialLoggedIn) {
      this.socialAuthService.signOut();
    }
    this.store.dispatch(new RemoveAuthAction());
    localStorage.removeItem(STATE_SNAPSHOT);
    localStorage.removeItem(STATE_TIMESTAMP);
    this.googleTagManagerService.pushOnDataLayer({
      event: 'cerrar-sesion',
    });
    this.googleTagManagerService.pushBookingActionOnDataLayer({
      event_name: 'cerrar-sesion',
    });
    this.navigateToWhereAndWhen();
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private onErrorLogout(error: HttpErrorResponse): void {
    //console.log('on error logout', error);
  }

  private subscribeToSocialAuthState(): void {
    this.socialAuthService.authState
      .pipe(untilDestroyed(this))
      .subscribe((socialUser: SocialUser) => {
        this.socialLoggedIn = socialUser !== null;
      });
  }

  private checkLoggedUser(): void {
    if (
      this.authService.getAccessToken() &&
      !this.userData?.id &&
      !this.agencyData?.id
    ) {
      if (this.authService.isTokenValid()) {
        if (this.authService.isClient()) {
          this.usersApiService
            .getUser()
            .then((user: User) => this.store.dispatch(new SetUserAction(user)));

        } else if (this.authService.isAgency()) {
          this.agenciesApiService
            .getAgency()
            .then((agency: Agency) =>
              this.store.dispatch(new SetAgencyAction(agency))
            );
        }
      } else {
        this.authService.deleteAccessToken();
        this.onClickLogout();
      }
    }
  }

  private navigateToWhereAndWhen(): void {
    this.router.navigate(['/where-when']);
  }

  openLoginModal(): void {
    this.dialog
      .open(LoginDialogComponent, {
        ...DIALOG_CONFIG,
        size: 'md',
        enableClose: false,
      })
      .afterClosed$.pipe(filter(Boolean), untilDestroyed(this))
      .subscribe(() => this.openSignUpDialog());
  }

  openSignUpDialog(): void {
    this.dialog
      .open(SignUpDialogComponent, {
        ...DIALOG_CONFIG,
        size: 'md',
        enableClose: false,
      })
      .afterClosed$.pipe(filter(Boolean), untilDestroyed(this))
      .subscribe(() => this.openLoginModal());
  }

  cleanMessages(): void {
    this.store.dispatch(new RemoveUserMessageAction());
  }

  openChangeUserModeDialog(): void {
    this.dialog.open(ChangeUserModeDialogComponent, {
      closeButton: false,
      size: 'md',
      backdrop: true,
      data: {
        businessMode: this.isBusinessMode,
        profiles: this.userData.profiles,
      },
    });
  }

  get companyProfiles(): boolean {
    if (this.userData) {
      const haveCompanyProfiles = this.userData.profiles.some(
        (profile: Profile) => {
          return profile.hasOwnProperty('companyId');
        }
      );
      return haveCompanyProfiles;
    } else {
      return false;
    }
  }
}
